// extracted by mini-css-extract-plugin
export var box = "_q-2";
export var checkboxControl = "_q-0";
export var checkboxRow = "_q-a";
export var checked = "_q-3";
export var descriptionSpacer = "_q-c";
export var disabled = "_q-4";
export var icon = "_q-8";
export var input = "_q-1";
export var labelSpacer = "_q-b";
export var large = "_q-7";
export var medium = "_q-6";
export var small = "_q-5";
export var text = "_q-9";